import api from "./api";

export function getAllCategories() {
  return api.get("user/categories");
}
export function getAllCategoriesWithCodes() {
  return api.get("user/categories-with-codes");
}

